"use client"

import CartTotals from "@modules/common/components/cart-totals"
import DiscountCode from "@modules/checkout/components/discount-code"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { HttpTypes } from "@medusajs/types"

type SummaryProps = {
  cart: HttpTypes.StoreCart
}

function getCheckoutStep(cart: HttpTypes.StoreCart) {
  if (!cart?.shipping_address?.address_1 || !cart.email) {
    return "address"
  } else if (cart?.shipping_methods?.length === 0) {
    return "delivery"
  } else {
    return "payment"
  }
}

const Summary = ({ cart }: SummaryProps) => {
  const step = getCheckoutStep(cart)

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <h2
        style={{
          fontSize: 13,
          fontWeight: 700,
          color: "#002035",
          margin: 0,
          letterSpacing: "-0.01em",
          fontFamily: "ui-monospace, SF Mono, Menlo, monospace",
          textTransform: "uppercase",
        }}
      >
        Order summary
      </h2>

      <DiscountCode cart={cart} />

      <div style={{ borderTop: "1px solid #e5e7eb" }} />

      <CartTotals totals={cart} />

      <LocalizedClientLink
        href={"/checkout?step=" + step}
        data-testid="checkout-button"
        style={{
          display: "block",
          textAlign: "center",
          background: "#04414d",
          color: "#fff",
          padding: "12px 16px",
          fontFamily: "ui-monospace, SF Mono, Menlo, monospace",
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          borderRadius: 8,
          textDecoration: "none",
        }}
      >
        Go to checkout →
      </LocalizedClientLink>
    </div>
  )
}

export default Summary
